import { Component, OnInit } from '@angular/core';
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-sass-two-features',
  templateUrl: './sass-two-features.component.html',
  styleUrls: ['./sass-two-features.component.scss']
})
export class SassTwoFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

    getUrlSignup(){
        return `${environment.url}?redirect=signup`;
    }
}
